<template>
    <div class="main-content-container container-fluid ">
        <div class="row mt-4 wiagro_userProfile">

            <w-card size="100">
                <div class="row">
                    <div class="col-12 col-md-12 col-lg-6">
                        <h6>{{$t("PROFILE.USER_PROFILE")}}</h6>
                        <label class="m-0">{{$t("PROFILE.NAME")}}:</label>
                        <el-input class="my-2" v-model="user.name" :maxlength="40" />
                        <label class="m-0">{{$t("PROFILE.CONTACT_PHONE")}}:</label>
                        <el-input class="my-2" v-model="user.tel" :maxlength="30" />
                        <label class="m-0">{{$t("PROFILE.EMAIL")}}:</label>
                        <el-input class="my-2" v-model="user.mail" :maxlength="390" />

                        <h6 class="mt-3">{{$t("PROFILE.TIMEZONE")}}</h6>
                        <el-select class="w-100" v-model="selectedTimezone" placeholder="Selecciona" @change="handleTimezoneChange" filterable>
                        <el-option
                            v-for="timezone in timezones"
                            :key="timezone"                            
                            :label="getOptionLabel(timezone)"
                            :value="timezone"
                        />
                        </el-select>
                    </div>

                    <div class="col-12 col-md-12 col-lg-6">
                        <h6>{{$t("PROFILE.UNITS")}}</h6>
                        <label>{{$t("COMMON.TEMPERATURE")}}:</label>
                        <el-select v-model="temperature" class="w-100 mb-2" placeholder="Seleccionar">
                            <el-option value="c" :label="$t('PROFILE.CELSIUS')">

                            </el-option>
                            <el-option value="f" :label="$t('PROFILE.FAHRENHEITS')">

                            </el-option>
                        </el-select>
                        <label class="mt-1">{{$t("COMMON.CO2")}}:</label>
                        <el-select v-model="co2" class="w-100" placeholder="Seleccionar">
                            <el-option value="%" :label="$t('PROFILE.PERCENTAGE')">
                            </el-option>
                            <el-option value="p" :label="$t('PROFILE.PPM')">

                            </el-option>
                        </el-select>
                        <h6 class="mt-3">{{$t("PROFILE.SILO_DETAIL")}}</h6>
                        <el-switch
                            v-model="siloDetails" @change="changeDetails()" >
                        </el-switch>
                    </div>
                </div>
                <div class="row mt-md-4 mt-4">
                    <div class="col-12 text-right">
                        <div class="msg">{{ $t("PROFILE.EDIT_MESSAGE") }}</div>
                        <el-button disabled type="plain" @click="updatePassword()"> {{$t('PROFILE.CHANGE_PASSWORD')}}</el-button>
                        <el-button disabled type="primary" @click="updateUser()">{{$t("COMMON.SAVE")}}</el-button>
                    </div>
                </div>
            </w-card>

                <el-dialog
                        :title="$t('PROFILE.NEW_PASSWORD')"
                        :visible.sync="showPasswordModal"     
                        :fullscreen="isFullscreen"
                        >
                        <div class="dialog-content" ref="dialogContent">
                        <el-form 
                            :model="passwordForm" 
                            ref="passwordForm"
                            :rules="rules"
                            >
                            <el-form-item :label="$t('PROFILE.NEW_PASSWORD')"  prop="password">
                                <el-input
                                    v-model="passwordForm.password"
                                    type="password"
                                    show-password
                                    autocomplete="new-password"
                                    :maxlength="30"
                                    >
                                </el-input>
                            </el-form-item>
                            <el-form-item :label="$t('PROFILE.CONFIRM_PASSWORD')"  prop="confirmPassword">
                                <el-input
                                    v-model="passwordForm.confirmPassword"
                                    type="password"
                                    show-password
                                    autocomplete="new-password"
                                    :maxlength="30"
                                    >
                                </el-input>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="showPasswordModal = false">{{ $t('COMMON.CANCEL') }}</el-button>
                            <el-button type="primary" :disabled="changePasswordSaveButtonEnabled() === false" @click="submitPasswordForm">{{ $t('COMMON.SAVE') }}</el-button>
                        </div>
                        </div>
                </el-dialog>
        </div>
    </div>
</template>

<script>
    import wCard from "../components/common/wCard";
    import api from "../utils/api/api";
    import mutations from "../utils/store/mutations";
    import routesNames from "../utils/router/routesNames";
    import moment from 'moment-timezone';

    export default {
        name: "userProfile",
        components: {
            "w-card": wCard
        },
        data: function () {
            return {
                user: JSON.parse(JSON.stringify(this.$store.state.user)),
                co2: this.$store.state.user.units.split(",")[1],
                temperature: this.$store.state.user.units.split(",")[0],
                siloDetails: false,
                timezones: moment.tz.names(),
                //selectedTimezone: moment.tz.guess(), // Selecciona la zona horaria local por defecto
                selectedTimezone: this.$store.state.user.tzname, // Selecciona la zona horaria del usuario
                showPasswordModal: false,
                isFullscreen: false,
                passwordForm: {
                    password: '',
                    confirmPassword: ''
                },
                rules: {
                    password: [
                        //{required: true, message: this.$t("PROFILE.FILL_NEW_PASSWORD")}
                        { required: true, message: this.$t('PROFILE.FILL_NEW_PASSWORD'), trigger: 'blur' },
                        { message: this.$t('PROFILE.MAX_LENGTH_EXCEEDED'), trigger: 'blur' }
                    ],
                    confirmPassword: [
                        //{required: true, message: this.$t("PROFILE.FILL_CONFIRM_PASSWORD")}
                        { required: true, message: this.$t('PROFILE.FILL_CONFIRM_PASSWORD'), trigger: 'blur' },
                        { validator: this.validateConfirmPassword, trigger: 'blur' }                    
                    ]
                }
            }
        },
        mounted()
        {
            this.siloDetails = this.$store.state.viewDetails;
            window.addEventListener('resize', this.handleResize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
        },
        computed: {
            dialogWidth() {
                return this.windowWidth < 600 ? '100%' : '50%'; // Ajusta el ancho para pantallas grandes aquí
            }
        },
        methods: {
            handleResize() {
                this.isFullscreen = window.innerWidth < 600;
            },
            getOptionLabel(timezone) {
                const offset = moment.tz(timezone).format('Z');
                const zoneCode = moment.tz.zone(timezone).abbr();
                return `[GMT${offset}] ${timezone} (${zoneCode})`;
            },
            handleTimezoneChange() {
                // Función que se ejecutará cuando cambie la zona horaria seleccionada
                //console.log('Zona horaria seleccionada:', this.selectedTimezone);
                const offset = moment.tz(this.selectedTimezone).format('Z');
                //const tz = moment.tz(this.selectedTimezone);                
                //console.log("Tz: ",tz);
                const offsetMinutes = moment.duration(offset).asMinutes();
                //console.log("Offset en minutos: ",offsetMinutes);
                const hours = Math.floor((offsetMinutes) / 60);
                console.log("Offset en Horas: ",hours," Provision: ",hours+3);
                this.user.tzname = this.selectedTimezone;
                this.user.timezone = hours+3;
                
            },
            setLocalTz() {
                // Función que se ejecutará cuando se seleccione la zona horaria local
                this.selectedTimezone = moment.tz.guess();
            },
            updateUser() 
            {
                this.user.units = [{
                    temp: this.temperature,
                    co2: this.co2
                }];
                this.user.lastname = "";

                api.updateUser(this.user).then(value => {
                    let userToUpdate = JSON.parse(JSON.stringify(this.user));
                    userToUpdate.units = this.temperature + "," + this.co2;
                    delete userToUpdate.password;
                    this.$store.commit(mutations.UPDATE_USER, userToUpdate);
                    this.$alert(this.$t('PROFILE.LOGOUT_MESSAGE'), '', {
                        confirmButtonText: this.$t('PROFILE.LOGOUT'),
                        showClose: false,
                        callback: () => {
                            api.logout(this.$store.state.user.id, this.$store.state.token).finally(() => {
                                this.$store.commit(mutations.DELETE_STORE);
                                this.$router.push({name: routesNames.LOGIN})
                            })
                        }

                    });

                }).catch(reason => {
                    this.$message.error(this.$t("COMMON.SAVE_FAILURE"));
                    console.error("no se guardo nada", reason);
                });
            },
            updatePassword() {
                
                this.showPasswordModal = true;
                this.passwordForm.password = "";
                this.passwordForm.confirmPassword = "";

                return;

                this.$prompt(this.$t('PROFILE.FILL_NEW_PASSWORD'), this.$t('PROFILE.NEW_PASSWORD'), {
                    confirmButtonText: this.$t('COMMON.SAVE'),
                    cancelButtonText: this.$t('COMMON.CANCEL'),
                    showInput: true,
                    inputType: "password",
                    /*inputValidator: function (value) {
                        return !(value === undefined || value === null || value === "");
                        
                    },
                    */
                    inputValidator: (value) => {
                        if (!value || value.trim() === "") 
                        {
                            return this.$t('PROFILE.FILL_NEW_PASSWORD');
                        }
                        if (value.length > 44) {
                            return this.$t('PROFILE.MAX_LENGTH_EXCEEDED'); // Assumes you have this translation key
                        }
                        return true;
                    },                
                    inputErrorMessage: this.$t('PROFILE.FILL_NEW_PASSWORD'),
                    beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        const value = instance.inputValue;
                        if (!value || value.trim() === "" || value.length > 44) {
                            instance.editorErrorMessage = !value || value.trim() === "" 
                                ? this.$t('PROFILE.FILL_NEW_PASSWORD') 
                                : this.$t('PROFILE.MAX_LENGTH_EXCEEDED');
                        } 
                        else 
                        {
                            done();
                        }
                    } 
                    else 
                    {
                        done();
                    }
                    }
                }).then(({value}) => {
                    this.user.password = value;
                    this.updateUser();
                }).catch(() => {
                    console.info("Cambio de contraseña cancelado");
                });
            },
            checkPasswordMatch() {
                return this.passwordForm.password === this.passwordForm.confirmPassword;
            },
            changePasswordSaveButtonEnabled()
            {
                if(this.passwordForm.password == "")
                {
                    return false;
                }
                if(this.passwordForm.confirmPassword == "")
                {
                    return false;
                }
                return this.checkPasswordMatch();
            },
            validateConfirmPassword(rule, value, callback) {
                if (!this.checkPasswordMatch()) 
                {
                    callback(new Error(this.$t('PROFILE.PASSWORDS_DO_NOT_MATCH')));
                } 
                else 
                {
                    callback();
                }
            },
            submitPasswordForm() {
                this.$refs.passwordForm.validate((valid) => {
                    if (valid) {
                        this.user.password = this.passwordForm.password;
                        this.updateUser();
                        this.showPasswordModal = false;
                    }
                });
            },
            changeDetails() {
                console.log("cambio de detalles");
                this.$store.commit(mutations.CHANGE_VIEW_DETAILS, this.siloDetails);
                let message = "";
                let title = this.$t('PROFILE.CONF_CHANGE');
                if(this.siloDetails)
                {
                    message = this.$t('PROFILE.SILO_DETAIL_ENABLE');
                }
                else
                {
                    //message = this.$t('PROFILE.DETAILS_OFF');
                    message = this.$t('PROFILE.SILO_DETAIL_DISABLE')
                }
                this.$alert(message, title, {
                        confirmButtonText: this.$t('PROFILE.CONTINUE'),
                        showClose: false,
                        callback: () => {
                            this.$router.push("/dashboard");
                        }

                    });
                //this.$router.push({name: routesNames.DASHBOARD});
            }
        }
    };
</script>

<!--
<style scoped lang="scss">
    .el-input.is- .el-input__inner {
        background-color: #fff;
        color: inherit;
        cursor: auto;
    }

    .el-dialog__body {
  max-height: 100%; /* Ajusta la altura según sea necesario */
  overflow: auto;
}
.dialog-content-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.dialog-content {
  flex: 1;
  overflow: auto;
}

.dialog-footer {
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 10px 0;
  text-align: right;
  border-top: 1px solid #ebeef5;
}

/*.pass-dialog {
  width: auto;
  height: auto;
  max-width: 600px;
}
*/
.responsive-dialog {
  width: auto; // Ancho por defecto

  @media (max-width: 800px) {
    width: 100%; // Ancho para pantallas menores a 800px
  }
}

</style>

-->

<style scoped lang="scss">
.el-input__inner {
  background-color: #fff;
  color: inherit;
  cursor: auto;
}

.el-dialog__body {
  max-height: 100%; /* Ajusta la altura según sea necesario */
  overflow: auto;
}

.dialog-content-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.dialog-content {
  flex: 1;
  overflow: auto;
}

.dialog-footer {
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 10px 0;
  text-align: right;
  border-top: 1px solid #ebeef5;
}
.msg {
  color: red;
  //Bold
    font-weight: bold;
}

.responsive-dialog {
  width: auto; /* Ancho por defecto */

  @media (max-width: 600px) {
    width: 100% !important; /* Ancho para pantallas menores a 800px */
  }
}
</style>
